import EdForm from './src/EdForm.vue'

/* istanbul ignore next */
EdForm.install = function (Vue) {
  Vue.component(EdForm.name, EdForm)
}

export default EdForm
